// import menu1 from '../../../assets/logo.png'
export default {
  name: 'HEADER',
  data() {
    return {
      // 收起菜单图标样式
      isscollop: this.$store.state.menu.isCollapse ? 'upScollop' : 'onScollop',
      flag: 0, // 是否全屏展示,
      username: '',
      DrawerFlag: false,
      systemInfo: {}
    }
  },
  created() {
    // 获取系统信息
    this.systemInfo = JSON.parse(this.$store.getters['menu/getSYSTEMINFO'])
    const userInfo = JSON.parse(this.$store.getters['menu/getUSERINFO'])
    this.username = userInfo.vName
  },
  methods: {
    collapse() {
      this.$store.commit(
        'menu/setIsCollapse',
        !this.$store.state.menu.isCollapse
      )
    },
    // 点击按钮触发的方法
    toggleFullscreen() {
      this.flag++
      this.flag % 2 === 0
        ? this.outFullCreeen(document)
        : this.FullCreeen(document.documentElement)
    },
    // 进入全屏的方法
    FullCreeen(element) {
      const el = element
      const rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen
      // Element.requestFullscreen() 此方法用于发出异步请求使元素进入全屏模式。
      // 调用此API并不能保证元素一定能够进入全屏模式。如果元素被允许进入全屏幕模式，
      // document对象会收到一个fullscreenchange事件，通知调用者当前元素已经进入全屏模式。如果全屏请求不被许可，则会收到一个fullscreenerror事件。
      if (typeof rfs !== 'undefined' && rfs) {
        rfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // eslint-disable-next-line no-undef
        const wscript = new ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
    },
    // 退出全屏的方法
    outFullCreeen(element) {
      const el = element
      const cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen
      if (typeof cfs !== 'undefined' && cfs) {
        cfs.call(el)
      } else if (typeof window.ActiveXObject !== 'undefined') {
        // eslint-disable-next-line no-undef
        const wscript = new ActiveXObject('WScript.Shell')
        if (wscript != null) {
          wscript.SendKeys('{F11}')
        }
      }
    }
  },
  computed: {
    RetractableExpansion() {
      return this.$store.state.menu.isCollapse
    }
  },
  watch: {
    RetractableExpansion(newVal, oldVal) {
      if (newVal) {
        this.isscollop = 'upScollop'
      } else {
        this.isscollop = 'onScollop'
      }
    }
  }
}
